import { render, staticRenderFns } from "./kpp-aghk.vue?vue&type=template&id=72626462"
import script from "./kpp-aghk.vue?vue&type=script&lang=js"
export * from "./kpp-aghk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports